import React, { useState, useEffect } from "react";
import {
  Modal,
  Form,
  Input,
  InputNumber,
  Select,
  Upload,
  message,
  Space,
} from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { getDirectusClient } from "../../../lib/directus";
import { createItem, readItems, uploadFiles } from "@directus/sdk";
import moment from "moment";
import { useSelector } from "react-redux";

const { Option } = Select;
const { Dragger } = Upload;

const ConsignacionModal = ({ visible, liquidacionId, onClose, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [bancos, setBancos] = useState([]);
  const [fileId, setFileId] = useState(null);
 
  console.log("liquidacionId", liquidacionId);

  
  useEffect(() => {
    fetchBancos();
  }, []);

  const fetchBancos = async () => {
    try {
      const directus = await getDirectusClient();
      const response = await directus.request(
        readItems("bancos", {
          fields: ["id", "nombre"],
        })
      );
      setBancos(response);
    } catch (error) {
      console.error("Error fetching bancos:", error);
      message.error("Error al cargar los bancos");
    }
  };

  const handleFileUpload = async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const directus = await getDirectusClient();
      const response = await directus.request(uploadFiles(formData));

      if (response.id) {
        setFileId(response.id);
        message.success("Evidencia subida correctamente");
        return false; // Prevent default upload
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      message.error("Error al subir la evidencia");
    }
    return false;
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      if (!fileId) {
        message.error("Por favor suba una evidencia");
        return;
      }

      if (!liquidacionId) {
        message.error("No hay liquidación activa");
        return;
      }

      // Get user's active caja
      const directus = await getDirectusClient();
     
      

      const consignacionData = {
        nombre: values.nombre,
        monto: values.monto,
        evidencia: fileId,
        referencia: values.referencia,
        banco: values.banco,
        tipo: "tropas",
        liquidacion: liquidacionId,
      };

      await directus.request(createItem("consignaciones", consignacionData));
      message.success("Consignación creada exitosamente");
      
      form.resetFields();
      setFileId(null);
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      console.error("Error creating consignacion:", error);
      message.error("Error al crear la consignación");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setFileId(null);
    onClose();
  };

  const uploadProps = {
    name: "file",
    multiple: false,
    accept: "image/*",
    beforeUpload: handleFileUpload,
    showUploadList: true,
  };

  return (
    <Modal
      title="Nueva Consignación"
      open={visible}
      onCancel={handleCancel}
      onOk={handleSubmit}
      confirmLoading={loading}
      width={600}
      destroyOnClose={true}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="nombre"
          label="Nombre"
          rules={[{ required: true, message: "Por favor ingrese el nombre" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="monto"
          label="Monto"
          rules={[{ required: true, message: "Por favor ingrese el monto" }]}
        >
          <InputNumber
            style={{ width: "100%" }}
            min={0}
            formatter={(value) =>
              `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
          />
        </Form.Item>

        <Form.Item
          name="referencia"
          label="Referencia"
          rules={[
            { required: true, message: "Por favor ingrese la referencia" },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="banco"
          label="Banco"
          rules={[{ required: true, message: "Por favor seleccione el banco" }]}
        >
          <Select placeholder="Seleccione un banco">
            {bancos.map((banco) => (
              <Option key={banco.id} value={banco.id}>
                {banco.nombre}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Evidencia"
          required
          tooltip="Suba una imagen como evidencia"
        >
          <Dragger {...uploadProps}>
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              Click o arrastre una imagen para subirla
            </p>
            <p className="ant-upload-hint">
              Solo se permiten archivos de imagen
            </p>
          </Dragger>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ConsignacionModal;
